import React from 'react';
import { Link } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { TOKEN_KEY, TOKEN_DATE } from '../store/auth';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPublic } from '../store/auth';

//LAYOUT
import PublicLayout from '../layouts/public';

//COMPONENTS
import {Logo, Button} from '../components/inspinia'
import PublicInput from '../components/publicInput';

import { isBlank } from '../helpers/stringHelper';

class RecuperarSenha extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            user: { email: '', password: '' },
            loading: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }   

    handleChange(e)
    {
        const user = this.state.user;

        this.setState({ user: { ...user, [e.target.name]: e.target.value } });
    }

    handleSubmit(e) {
        e.preventDefault();
    
        if (isBlank(this.state.user.email)) {
            c.TOASTER_ERROR("Favor preencher email.");
        } else {
            const options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: this.state.user.email
                })
            };

            const url = `${c.REDEFINIR_SENHA}`;
            
            fetch(url, options)
                .then(async (response) => {
                    const json = await response.json();

                    if (response.ok) {
                        // Limpa token e estado
                        localStorage.removeItem(TOKEN_KEY);
                        localStorage.removeItem(TOKEN_DATE);

                        if (this.props.actions?.auth?.logoutFinished) {
                            this.props.actions.auth.logoutFinished();
                        }

                        this.props.history.push({
                            pathname: c.LOGIN_ROUTE,
                            state: {
                                senhaRecuperada: true,
                                mensagem: json.message
                            }
                        });
                    } else {
                        c.TOASTER_ERROR(json.message);
                    }
                })
                .catch(err => {
                    console.log("fetch error", err);
                    c.TOASTER_ERROR("Erro inesperado ao tentar redefinir senha.");
                });
        }
    }

    render()
    {
        const user = this.state.user;

        return (
            <PublicLayout history={this.props.history}>
                <div>
                    <div className="mb-4 text-center">
                        <Logo />
                    </div>
                
                    <div className="ibox-content text-center" style={{"width": "345px", "height": "372px", "padding": "39px 33px", "borderRadius": "10px", "boxShadow": "1px 3px 10px 0 rgba(0, 0, 0, 0.3)"}}>
                        <h3 className="mt-0 fs-20 fw-600 text-body">
                            Recuperar sua Senha
                        </h3>

                        <h5 className="text-muted fs-12 fw-300 mx-4 mb-5">
                            Insira o endereço de e-mail que utilizou para se inscrever e iremos enviar um 
                            e-mail com as instruções.
                        </h5>

                        <form className="form-signin m-t" >
                            
                            <PublicInput type="email" 
                                name="email" 
                                placeholder="E-mail" 
                                value={user.email} 
                                onChange={this.handleChange} 
                                img="/assets/images/user-icon.svg" />

                            <Button onClick={this.handleSubmit} className="btn btn-lg btn-primary block full-width m-b mb-0">ENVIAR</Button>
                                    
                        </form>

                        <div className="clearfix mx-4 mb-4">
                            <span className="fs-12 text-body">
                                Não recebeu o e-mail? <br/><a 
                                onClick={() => this.handleSubmit()}
                                style={{color: "#01bc8e"}}>Clique aqui</a> para enviar novamente.
                            </span>
                        </div>
                    </div>
   
                    <div className="mb-0 py-4 px-0 text-left">
                        <Link to={c.LOGIN_ROUTE} className="text-light" style={{visibility: ""}}>
                            <i className="fa fa-long-arrow-left"></i> Voltar 
                        </Link>
                    </div>
                </div>

            </PublicLayout>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { auth: bindActionCreators(authActionPublic, dispatch) } };
}

export default connect(mapStateToProps, mapDispatchToProps)(RecuperarSenha);
